module.exports = __webpack_public_path__ + "img/download_dianshi_text.90ded5fa.png";